import { motion, useReducedMotion } from 'framer-motion';

import pt from '../../locales/pt';
import { LANDING_EASE } from './ScrollReveal';

/**
 * Feature visual — ds/card/goal-progress pattern on Landing.
 */
export function GoalMiniApp() {
  const data = pt.landing.features.miniGoal;
  const reduceMotion = useReducedMotion();

  return (
    <div className="w-full max-w-[340px] rounded-ds-xl border border-border bg-card p-space-6">
      <p className="font-display text-type-title-card font-semibold text-foreground">{data.title}</p>
      <p className="type-body-sm mt-space-1 text-muted-foreground">{data.subtitle}</p>
      <ul className="mt-space-4 flex flex-col gap-space-4">
        {data.rows.map((row) => (
          <li key={row.label}>
            <div className="flex items-baseline justify-between gap-space-2">
              <span className="type-body font-semibold text-foreground">{row.label}</span>
              <span className="type-body-sm tnum text-muted-foreground">
                {row.saved} / {row.target}
              </span>
            </div>
            <div className="mt-space-2 h-2 overflow-hidden rounded-ds-full bg-stone-100 dark:bg-stone-700">
              <motion.div
                className="h-full rounded-ds-full bg-sage-500"
                initial={reduceMotion ? false : { width: 0 }}
                whileInView={{ width: `${row.trackPct}%` }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, delay: 0.2, ease: LANDING_EASE }}
              />
            </div>
            <p className="type-caption mt-space-1 text-muted-foreground">{row.progress}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
